import api from "../..";
import type { ApiResponse } from "../../types";
import type { GetHomeStatsParams, HomeStatsChartResponse } from "./types";

export const getHomeStats = async ({ params }: GetHomeStatsParams): Promise<HomeStatsChartResponse | null> => {

  return await api.get<ApiResponse<HomeStatsChartResponse>>("/admin/home/stats/", { params })
  .then(res => res.data.data)
  .catch(() => {return null});
};
